@use 'themes/westfield' as *;
// Form Row
//=========

@use 'tools/dirg' as *;
@use './field.module' as *;

.rowWrapper {
  @extend .fieldWrapper;
  width: 100%;
}

.Row {
  display: flex;
  flex-flow: row wrap;
  align-items: flex-start;
  width: 100%;

  > * {
    flex: 1;
  }
}

.RowDefault {
  > * + * {
    margin-left: units(2);
  }
}

.RowSmall {
  > * + * {
    margin-left: units(1.5);
  }
}
